function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_3718",
  "data-name": "Group 3718",
  transform: "translate(-183.49 -306.001)"
}, React.createElement("path", {
  id: "Path_2944",
  "data-name": "Path 2944",
  d: "M-12127.273-15600.893v28.793",
  transform: "translate(12324.073 15906.894)",
  fill: "none",
  stroke: "#7c7c7c",
  strokeWidth: 3,
  strokeDasharray: 4
}), React.createElement("g", {
  id: "baseline-keyboard_arrow_down-24px",
  transform: "translate(165 301)"
}, React.createElement("path", {
  id: "Path_1411",
  "data-name": "Path 1411",
  d: "M9.128,8.59,19.313,18.752,29.5,8.59l3.128,3.128L19.313,25.031,6,11.718l1.465-1.465Z",
  transform: "translate(12.49 19.66)",
  fill: "#7c7c7c"
})));

var SvgTransferDownIcon = function SvgTransferDownIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 26.625,
    height: 39.69,
    viewBox: "0 0 26.625 39.69",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTransferDownIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transferDownIcon.1069eca3.svg";
export { ForwardRef as ReactComponent };